module.exports = __webpack_public_path__ + "static/cloak_of_elvenkind-8fa243401fbbf7f16a6d5cd803e186b1.jpeg";